import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { TextLabel } from "../components/TextLabel";
import { ChipsReadonly } from "../components/ChipsReadonly";
import { Progress } from "../components/Progress";
import OrganizationName from "../containers/OrganizationName";
import { GlobalAccessCheckbox } from "../components/GlobalAccessCheckbox";
import { stringList } from "../utils/stringUtils";
import { downloadStorageFile, currentUserIsRole } from "../redux/actions/utils";
import { makeAppDefaultVersion } from "../redux/actions/appActions";
import { ShowHide } from "../components/ShowHide";
import { ADMIN, SUPER_ADMIN } from "../utils/userRoles";
import { withStyles } from "@material-ui/core/styles";
import Chip from '@material-ui/core/Chip';
import { useDispatch } from 'react-redux'

const styles = theme => ({
  button: {
    marginLeft: theme.spacing(1),
    textTransform: "none"
  }
});

export const ManagedAppInfoDialog = withStyles(styles)(({
  onClose,
  onEdit,
  onDelete,
  app: {
    title,
    packageName,
    latestVersion,
    versionName,
    apkUrl,
    vrTypes,
    categories,
    description,
    iconUrl,
    doNotDelete,
    organizationRef,
    globalAccess,
    obbUrls,
    sortPriority = 0,
    defaultVersion,
    _id
  },
  loading,
  classes
}) => {
  const dispatch = useDispatch()

  return (
    <Dialog maxWidth="lg" scroll="body" onClose={onClose} open>
      <DialogTitle
        onEdit={onEdit}
        onDelete={onDelete}
        doNotDelete={doNotDelete}
        organizationRef={organizationRef}
      >
        Managed App: {title}
        {defaultVersion ?
          <Chip label="Default Version" size="small" className={classes.button} style={{ fontWeight: 'normal' }} />
          :
          <Button
            aria-label="Commands"
            variant="contained"
            onClick={() => makeAppDefaultVersion(_id, dispatch)}
            className={classes.button}
          >
            Make Default App Version
        </Button>
        }
      </DialogTitle>
      <DialogContent>
        {loading && <Progress />}
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TextLabel label="Title" value={title} />
            <TextLabel label="Package Name" value={packageName} />
            <TextLabel label="Version Number" value={latestVersion} />
            <TextLabel label="Version Name" value={versionName} />
            <br />
            <br />
            <ChipsReadonly
              data={categories}
              title="Categories"
              readonly={true}
            />
            <TextLabel label="Sort Priority" value={sortPriority} />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" display="block" gutterBottom>
              Icon
          </Typography>
            <img src={iconUrl} style={{ width: 100 }} />
            <br /><br /><br />
            <Typography variant="caption" display="block" gutterBottom>
              {obbUrls && obbUrls.length > 0 ? `OBB: main.${latestVersion}.${packageName}.obb` : ""}
            </Typography>
            <ShowHide show={currentUserIsRole(ADMIN) || currentUserIsRole(SUPER_ADMIN)}>
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={() => downloadStorageFile(apkUrl)}
              >
                Download APK
              </Button>
              <br></br>
              <br></br>
              <ShowHide show={!!obbUrls && obbUrls.length > 0}>
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  onClick={() => downloadStorageFile(obbUrls[0])}
                >
                  Download OBB
              </Button>
              </ShowHide>
            </ShowHide>
          </Grid>
          <Grid item xs={12}>
            <TextLabel label="Description" value={description} />
            <OrganizationName organizationRef={organizationRef} />
            <GlobalAccessCheckbox value={globalAccess} readonly />
          </Grid>
        </Grid>
        <br />
      </DialogContent>
    </Dialog>
  )
});
